import React, { useContext, useMemo } from 'react'
import { Button, Row, Col } from 'react-bootstrap'
import { DesignContext } from 'contexts/DesignContext'
import objectPath from 'object-path'

const RichTextPattern = (props) => {
  const designContext = useContext(DesignContext)
  const { jsonForm, updateUiSchema, setFormData, designerProps } = designContext
  let { uischema, config } = props
  const { isDynamic = false, dynamicName = '', dynamicIndex = 0 } = config
  let formData = jsonForm?.formData || {}
  let pattern = objectPath.get(uischema, 'pattern')

  const uiKey = useMemo(() => {
    if (isDynamic) {
      if (designerProps) {
        let elementName = designerProps.filter(
          ({ propType }) => propType === 'name'
        )
        let uiName = elementName.find(
          ({ prop }) => `@${prop}` === uischema.name
        )
        if (uiName) {
          return uiName.systemName
        }
      }
      return uischema.name
    }
    return uischema.key
  }, [isDynamic])

  const loadPattern = () => {
    if (!pattern) return
    objectPath.set(formData, uischema.key, pattern)
    setFormData(formData)
  }

  const savePattern = () => {
    let newPattern
    if (isDynamic) {
      newPattern = objectPath.get(
        formData,
        `${dynamicName}.${dynamicIndex}.${uiKey}`
      )
    } else {
      newPattern = objectPath.get(formData, uischema.key)
    }
    updateUiSchema(uischema.key, 'pattern', newPattern)
  }

  return (
    <Row className="my-2 mx-0">
      <Col sm="auto" className="pr-0 ml-auto">
        <Button
          className="btn-icon"
          onClick={loadPattern}
          variant="outline-secondary"
        >
          <i className="feather icon-download-cloud"></i> โหลด Pattern
        </Button>
      </Col>
      <Col sm="auto" className="pr-0">
        <Button
          className="btn-icon"
          onClick={savePattern}
          variant="outline-primary"
        >
          <i className="feather icon-save"></i> บันทึก Pattern
        </Button>
      </Col>
    </Row>
  )
}

export default RichTextPattern
